import PremiumExperienceGridMobile from '../../../../components/containers/PremiumExperienceGridMobile';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'premium-experience-grid--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PremiumExperienceGridMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
